import { v4 as uuidv4 } from 'uuid'

import languages from '../../i18n/languages'

const method = (fieldData) => {
	let object = {
		_uid: uuidv4(),
		component: 'inputCheckbox',
		type: 'checkbox',
		mapping: {
			field: fieldData.name,
			type: fieldData.dataType
		},
		title: fieldData.label,
		label: {
			default: '' //languages.en.schemas.inputCheckbox.label
		},
		spacing: 'xl'
	}

	return object
}

export default method
